import { NodeViewWrapper, type ReactNodeViewProps } from "@tiptap/react";

export function PlaceholderView({ node }: ReactNodeViewProps) {
  return (
    <NodeViewWrapper as="span" className="kd-ph" title="Placeholder: replace it before exporting">
      {String(node.attrs.label ?? "")}
    </NodeViewWrapper>
  );
}
